import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "24",
  viewBox: "0 0 23 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Group" }, [
      _createElementVNode("path", {
        id: "Ellipse",
        d: "M23 12C23 18.3513 17.8513 23.5 11.5 23.5C5.14873 23.5 0 18.3513 0 12C0 5.64873 5.14873 0.5 11.5 0.5C17.8513 0.5 23 5.64873 23 12Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        id: "Vector",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.1958 8.00084C12.1958 7.86801 12.2464 7.74062 12.3365 7.64669C12.4266 7.55277 12.5488 7.5 12.6762 7.5H16.5196C16.647 7.5 16.7692 7.55277 16.8593 7.64669C16.9494 7.74062 17 7.86801 17 8.00084V12.0076C17 12.1404 16.9494 12.2678 16.8593 12.3617C16.7692 12.4556 16.647 12.5084 16.5196 12.5084C16.3922 12.5084 16.27 12.4556 16.1799 12.3617C16.0898 12.2678 16.0392 12.1404 16.0392 12.0076V9.40319L12.5676 13.8276C12.5251 13.8817 12.4722 13.9259 12.4124 13.9574C12.3525 13.9889 12.287 14.0069 12.22 14.0104C12.153 14.0139 12.0861 14.0027 12.0235 13.9776C11.9609 13.9525 11.9041 13.9141 11.8566 13.8647L9.3709 11.2733L5.85806 16.3088C5.78121 16.4106 5.66948 16.4775 5.54634 16.4953C5.42321 16.513 5.29825 16.4804 5.19774 16.4041C5.09722 16.3279 5.02898 16.214 5.00734 16.0863C4.9857 15.9587 5.01235 15.8273 5.0817 15.7198L8.92507 10.2105C8.96586 10.152 9.01836 10.1033 9.07893 10.0679C9.1395 10.0325 9.20672 10.0112 9.27594 10.0055C9.34517 9.99978 9.41476 10.0098 9.47992 10.0348C9.54508 10.0598 9.60426 10.0993 9.65339 10.1504L12.1602 12.7648L15.5059 8.50168H12.6762C12.5488 8.50168 12.4266 8.44891 12.3365 8.35499C12.2464 8.26106 12.1958 8.13367 12.1958 8.00084Z",
        fill: "#56B683"
      })
    ], -1)
  ])))
}
export default { render: render }